import { render, staticRenderFns } from "./SearchOrderBySelector.vue?vue&type=template&id=3de7fa96&"
import script from "./SearchOrderBySelector.vue?vue&type=script&lang=ts&"
export * from "./SearchOrderBySelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports